import type * as React from 'react';

import * as Styled from './notification-badge.styles';
const { variants } = Styled;

export type NotificationBadgeVariant = keyof typeof variants;
export type ChildrenType = string | number;
export type NotificationBadgeProps = React.ComponentProps<
  typeof Styled.NotificationBadge
> & {
  /** Content of the Notification Badge */
  children?: ChildrenType;
  /** Add custom CSS */
  className?: string;
  /** Defines the boundary after that the maximum number is shown with a “+” attached */
  maxNumber?: number;
  /** Hides the number of the badge */
  indeterminate?: boolean;
};
